// extracted by mini-css-extract-plugin
export default {"Services":"Services_Services__k3aq5","Icon":"Services_Icon__YZZ2O","zoom":"Services_zoom__cK+Mu"};